import { gql } from "@apollo/client";

const EVENT_SESSIONS = gql(`query EventSessions($eventId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  eventSessions(eventId: $eventId, startDate: $startDate, endDate: $endDate) {
    id
    eventId
    startDate
    endDate
    availableCapacity
    totalCapacity
    isPublished
    name
    seatsIoEventKey
    ticketTypes {
      id
      name
    }
    orderItems {
      quantity
      order {
        metadata
      }
    }
  }
}`);

const USER_EVENT_SESSIONS = gql(`query EventSessions($eventId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  eventSessions(eventId: $eventId, startDate: $startDate, endDate: $endDate) {
    id
    eventId
    startDate
    endDate
    availableCapacity
    totalCapacity
    isPublished
    name
    seatsIoEventKey
    ticketTypes {
      price
      id
      name
      available
      ticketOrder
      total
      isPublished
      series
      sellEndDate
      sellStartDate
      order
      description
      category {
        name
      }
      ticketSubcategory {
        name
      }
      promotionType
      promotionMetadata
      event {
        general {
          commissionPaidByUser
        }
          tickets {
            comission
          }
      }
    }
  }
}`);

const SESSION_TICKETS_REPORT = gql(`
  query SessionTicketsReport($id: ID!) {
  sessionTicketsReport(id: $id) {
    count
    label
  }
}
  `)

const EVENT_SESSION_AVAILABILITY = gql(`
  query EventSessionAvailability($eventId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  eventSessionAvailability(eventId: $eventId, startDate: $startDate, endDate: $endDate) {
    availableCapacity
    date
  }
}
  `)

const FIRST_AVAILABLE_SESSION = gql(`
  query Query($eventId: ID!, $startDate: DateTime!) {
  firstAvaiableSession(eventId: $eventId, startDate: $startDate)
}
  `)

const SEATING_MAP_SESSIONS = gql(`query SeatingMapSessions($eventId: ID!) {
  seatingMapSessions(eventId: $eventId) {
    id
    eventId
    startDate
    endDate
    availableCapacity
    totalCapacity
    isPublished
    name
    seatsIoEventKey
    ticketTypes {
      id
      name
    }
    chartEvent {
      id
      chart {
        id
        status
      }
    }
  }
}`)

const GET_EVENT_SESSIONS_FOR_CASHIER = gql`
  query GetEventSessionsForCashier($eventId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
    eventSessions(eventId: $eventId, startDate: $startDate, endDate: $endDate) {
      id
      name
      startDate
      endDate
      availableCapacity
      ticketTypes {
        id
        name
        price
        available
        kind
        isPublished
      }
    }
  }
`;


export { EVENT_SESSIONS, USER_EVENT_SESSIONS, SESSION_TICKETS_REPORT, EVENT_SESSION_AVAILABILITY, FIRST_AVAILABLE_SESSION, SEATING_MAP_SESSIONS, GET_EVENT_SESSIONS_FOR_CASHIER }

